import runeList from "@/assets/diablo2/data/rune.json";

const state = () => ({
  runeList: runeList,
});

const getters = {
  getRuneById: (state) => (id) => {
    for (var i = 0; i < state.runeList.length; i++) {
      if (state.runeList[i].id === id) {
        return state.runeList[i];
      }
    }
    return null;
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {},
  modules: {},
};
